import React, { useState, useEffect } from "react";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Input, Modal, ModalBody, ModalClose, Box, Button, Spacer, Text, Loader } from "@flexisaf/flexibull2";
import { Theme } from "./theme";




export const CustomDataSource = ({ onValueChange, value }: { onValueChange?: (url: string) => void, value?: string }) => {
    const [pulling, setPulling] = useState(false);
    const [preview, setPreview] = useState(false);
    const [validationError, setValidationError] = useState<string | null>(null);
    const [url, setUrl] = useState(value || '');
    const [data, setData] = useState(
        JSON.stringify({ 
            key1: ["value1", "value2", "..."], 
            key2: ["value1", "value2", "..."],
            key3: ["value1", "value2", "..."] 
        }, null, 2)
    );

    const validateStructure = (json: any): string | null => {
        if (!json || typeof json !== 'object' || Array.isArray(json)) {
            return 'Response must be a JSON object';
        }
        const keys = Object.keys(json);
        if (keys.length === 0) {
            return 'Object must have at least one key';
        }
        for (const key of keys) {
            if (!Array.isArray(json[key])) {
                return `"${key}" must be an array`;
            }
            if (json[key].length === 0) {
                return `"${key}" array cannot be empty`;
            }
        }
        return null;
    };

    const handlePullData = async (targetUrl = url) => {
        if (!targetUrl) return;
        try {
            new URL(targetUrl);
        } catch {
            setValidationError('Invalid URL format');
            return;
        }
        setPulling(true);
        try {
            const response = await fetch(targetUrl);
            if (!response.ok) {
                setValidationError(`Request failed: ${response.status} ${response.statusText}`);
                return;
            }
            const json = await response.json();
            const validationError = validateStructure(json);
            if (validationError) {
                setValidationError(validationError);
                return;
            }
            onValueChange?.(targetUrl);
            const result = JSON.stringify(json, null, 2);
            setData(result.length > 500 ? result.slice(0, 500) + "\n\n... (truncated)" : result);
            setValidationError(null);
        } catch (error: any) {
            setValidationError('Error fetching data: ' + error.message);
        } finally {
            setPulling(false);
        }
    };

    useEffect(() => {
        if (value) {
            setUrl(value);
            handlePullData(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    
    return <Box pad="20px 0">
        <Input
        label="Data Source URL"
        type="text"
        spaceTop
        spaceBottom="10px"
        required
        height="36px"
        block
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
      <Button progress={pulling} iconRight={<i className="form-arrows-ccw" />} onClick={() => handlePullData(url)}>Pull Data &amp; Validate</Button>
      <Spacer space="15px" />
      {validationError && <Text color="red">{validationError}</Text>}
      <Text color={Theme.PrimaryColor} style={{cursor: "pointer"}} onClick={()=> setPreview(true)}><i className="form-map-signs"/> View sample data structure</Text>
      <Spacer space="15px" />
      <Text bold block>Data Preview</Text>
      <Spacer space="10px" />
        {pulling ? <Loader size={40} color={Theme.PrimaryColor} />
        :<SyntaxHighlighter language="javascript" style={docco} wrapLines customStyle={{ fontSize: "9px"}}>
            {data}
        </SyntaxHighlighter>
        }
        <Modal open={preview} center={false}>
            <ModalBody width="400px" bgColor="rgb(248, 248, 255)">
            <ModalClose onClick={() => setPreview(false)}>&times;</ModalClose>
                <Box pad="30px">
                    <Text bold block size="16px">Sample Data Structure</Text>
                    <Spacer space="15px" />
                    <SyntaxHighlighter language="javascript" style={docco} wrapLines>
                        {data}
                    </SyntaxHighlighter>
                </Box>
            </ModalBody>
        </Modal>
    </Box>
};
